import React from 'react';
import { Stack, TextField } from '@mui/material';
import { isCustomerFieldRequired, type CustomerFieldErrorMap } from '../../customerCompleteness';
import type { CustomerFormDraft } from '../../customerFormDraft';

type Props = {
  draft: CustomerFormDraft;
  onChange: (patch: Partial<CustomerFormDraft>) => void;
  readOnly?: boolean;
  fieldErrors?: CustomerFieldErrorMap;
  requiredKeys?: ReadonlySet<keyof CustomerFormDraft>;
};

/** Kontak personal & alamat utama. */
export function CustomerFormAddressContactTabScreen({
  draft,
  onChange,
  readOnly = false,
  fieldErrors,
  requiredKeys,
}: Props) {
  const req = (key: keyof CustomerFormDraft) =>
    isCustomerFieldRequired(key, { readOnly, requiredKeys });
  return (
    <Stack spacing={2} sx={{ maxWidth: 560 }}>
      <TextField
        label="Alamat"
        value={draft.address}
        onChange={(e) => onChange({ address: e.target.value })}
        required={req('address')}
        error={Boolean(fieldErrors?.address)}
        helperText={fieldErrors?.address}
        fullWidth
        multiline
        minRows={2}
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-address' }}
      />
      <TextField
        label="Alamat LHU"
        value={draft.alamat_lhu}
        onChange={(e) => onChange({ alamat_lhu: e.target.value })}
        required={req('alamat_lhu')}
        error={Boolean(fieldErrors?.alamat_lhu)}
        helperText={fieldErrors?.alamat_lhu}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-alamat-lhu' }}
      />
      <TextField
        label="Kota"
        value={draft.city}
        onChange={(e) => onChange({ city: e.target.value })}
        required={req('city')}
        error={Boolean(fieldErrors?.city)}
        helperText={fieldErrors?.city}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-city' }}
      />
      <TextField
        label="Propinsi"
        value={draft.province}
        onChange={(e) => onChange({ province: e.target.value })}
        required={req('province')}
        error={Boolean(fieldErrors?.province)}
        helperText={fieldErrors?.province}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-province' }}
      />
      <TextField
        label="Kode pos"
        value={draft.postal_code}
        onChange={(e) => onChange({ postal_code: e.target.value })}
        required={req('postal_code')}
        error={Boolean(fieldErrors?.postal_code)}
        helperText={fieldErrors?.postal_code}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-postal-code' }}
      />
      <TextField
        label="No. telp"
        value={draft.phone}
        onChange={(e) => onChange({ phone: e.target.value })}
        required={req('phone')}
        error={Boolean(fieldErrors?.phone)}
        helperText={fieldErrors?.phone}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-phone' }}
      />
      <TextField
        label="No. HP / WA"
        value={draft.mobile_wa}
        onChange={(e) => onChange({ mobile_wa: e.target.value })}
        required={req('mobile_wa')}
        error={Boolean(fieldErrors?.mobile_wa)}
        helperText={fieldErrors?.mobile_wa}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-mobile-wa' }}
      />
      <TextField
        label="No Telp Finance"
        value={draft.no_telp_finance}
        onChange={(e) => onChange({ no_telp_finance: e.target.value })}
        required={req('no_telp_finance')}
        error={Boolean(fieldErrors?.no_telp_finance)}
        helperText={fieldErrors?.no_telp_finance}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-no-telp-finance' }}
      />
      <TextField
        label="Email"
        value={draft.email}
        onChange={(e) => onChange({ email: e.target.value })}
        type="email"
        required={req('email')}
        error={Boolean(fieldErrors?.email)}
        helperText={fieldErrors?.email}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-contact-email' }}
      />
    </Stack>
  );
}
